import React, { useEffect, useRef, useState, useMemo, useCallback } from "react";
import { Modal } from "react-bootstrap";
import MessagingList from "./MessagingList";
import LexicalEditor from "./Comman/LexicalEditor";
import { getCurrentUser } from "../app/store/auth";
import { useGetUserProfilePicQuery } from "../app/store/authApiSlice";
import {
  useLoadAppMsgListQuery,
  useUpdateMessageReadMutation,
  useAddAppMessageMutation,
} from "../app/store/messagesApiSlice";
import {
  useLoadComponentUserStatusQuery,
  useUpdateComponentsUserStatusMutation,
} from "../app/store/toolsApiSlice";
import { getAlert } from "../Services/appAlerts";
import { uploadFileToBlob } from "../Services/blobUploadService";

const MESSAGING_POPUP_STYLES = {
  modalContent: {
    borderRadius: "26px",
    overflow: "hidden",
    border: "1px solid rgba(226, 232, 240, 1)",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)",
  },
  modalDialog: {
    maxWidth: "920px",
  },
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.95) 100%)",
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "14px",
  },
  modalFooter: {
    padding: "16px 22px 20px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff"
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },
  headerIcon: {
    width: "46px",
    height: "46px",
    borderRadius: "15px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(79, 70, 229, 0.16) 100%)",
    color: "#4338ca",
    fontSize: "21px",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6)",
  },
  title: {
    fontSize: "22px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.1,
    margin: 0,
  },
  subtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px",
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 800,
    boxShadow: "0 8px 18px rgba(15, 23, 42, 0.06)",
    flexShrink: 0,
  },
  modalBody: {
    padding: "20px 22px 22px 22px",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
  },
  historyCard: {
    borderRadius: "20px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    padding: "12px",
    marginBottom: "20px",
    maxHeight: "380px",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column-reverse",
  },
  editorCard: {
    borderRadius: "20px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    padding: "18px",
  },
  sectionTitle: {
    fontSize: "15px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "12px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  fileList: {
    display: "grid",
    gap: "10px",
    marginBottom: "16px",
  },
  fileRow: {
    borderRadius: "14px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#f8fbff",
    padding: "10px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
  },
  fileMeta: {
    minWidth: 0,
    flex: 1,
  },
  fileName: {
    fontSize: "13px",
    fontWeight: 700,
    color: "#0f172a",
    wordBreak: "break-word",
  },
  fileSubtext: {
    fontSize: "11px",
    color: "#64748b",
    marginTop: "2px",
  },
  removeButton: {
    width: "30px",
    height: "30px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#ef4444",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    flexShrink: 0,
  },
  footerActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "20px",
  },
  closeAction: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#475569",
    padding: "10px 14px",
    fontSize: "12px",
    fontWeight: 800,
  },
  attachButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#475569",
    padding: "10px 16px",
    fontSize: "12px",
    fontWeight: 800,
  },
  sendButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "none",
    background: "linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)",
    color: "#ffffff",
    padding: "10px 20px",
    fontSize: "12px",
    fontWeight: 800,
    boxShadow: "0 14px 28px rgba(79, 70, 229, 0.2)",
  },
  sendButtonDisabled: {
    opacity: 0.58,
    boxShadow: "none",
    cursor: "not-allowed",
  },
  emptyHistory: {
    minHeight: "180px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    color: "#64748b",
    fontSize: "13px",
    lineHeight: 1.6,
  },
};

const formatFileSize = (sizeInBytes) => {
  if (!sizeInBytes && sizeInBytes !== 0) return "";
  if (sizeInBytes < 1024) return `${sizeInBytes} B`;
  if (sizeInBytes < 1024 * 1024) return `${(sizeInBytes / 1024).toFixed(1)} KB`;
  return `${(sizeInBytes / (1024 * 1024)).toFixed(1)} MB`;
};

const getPlainText = (html = "") =>
  html
    .replace(/<style[^>]*>.*?<\/style>/gis, "")
    .replace(/<script[^>]*>.*?<\/script>/gis, "")
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/\s+/g, " ")
    .trim();

const MessagingPopup = (props) => {
  const {
    msgShowHide,
    handleMsgModalShowHide,
    message,
    handleSendMessage,
    handleSupportMessage,
  } = props;

  const [documents, setDocuments] = useState([]);
  const [attachmentShowHide, setAttachmentShowHide] = useState(false);
  const [content, setContent] = useState("");
  const [editorResetKey, setEditorResetKey] = useState(0);
  const [btnSendProcess, setBtnSendProcess] = useState(false);

  const currentUser = useMemo(() => getCurrentUser(), []);
  const fileInputRef = useRef(null);

  const usrId = useMemo(() => {
    if (!currentUser) return null;
    return currentUser.linkUser || currentUser.id;
  }, [currentUser]);

  // RTK Query hooks
  const { data: appMsgListData } = useLoadAppMsgListQuery(message?.id, { skip: !message?.id || !msgShowHide });

  const { data: componentUserStatus } = useLoadComponentUserStatusQuery(
    { id: currentUser?.id, ciid: message?.ciid },
    { skip: !currentUser?.id || !message?.ciid || !msgShowHide }
  );

  const { data: userProfilePic } = useGetUserProfilePicQuery(currentUser?.id, { skip: !currentUser?.id || !msgShowHide });

  const [updateMessageRead, { isSuccess: isReadUpdateSuccess, reset: resetReadUpdate }] = useUpdateMessageReadMutation();
  const [addAppMessage, { data: addedNewMessageStatus, reset: resetAddAppMessage }] = useAddAppMessageMutation();
  const [updateComponentsUserStatus] = useUpdateComponentsUserStatusMutation();

  const profilePicData = useMemo(() => {
    return userProfilePic ? "data:image/jpeg;base64," + userProfilePic : null;
  }, [userProfilePic]);

  // Format and reverse message list reactively
  const messageList = useMemo(() => {
    if (!appMsgListData) return [];
    const formatted = appMsgListData.map((item) => {
      let author = "receive";
      let performer = item.fromName + " " + item.fromLastName;
      if (item.fromId === parseInt(usrId, 10)) {
        author = "send";
      }

      return {
        author,
        data: item.message,
        performer,
        date: item.messageDate,
        documents: item.documents,
        id: item.id,
        readStatus: item.readStatus,
        fromId: item.fromId,
      };
    });

    return [...formatted].reverse();
  }, [appMsgListData, usrId]);

  // Reset form inputs when message target changes
  useEffect(() => {
    setDocuments([]);
    setContent("");
    setEditorResetKey((key) => key + 1);
    setBtnSendProcess(false);
    if (fileInputRef.current) fileInputRef.current.value = "";
  }, [message]);

  // Mark messages as read when unread items are found in the open thread
  useEffect(() => {
    if (appMsgListData && message?.id && usrId) {
      const hasUnread = appMsgListData.some(
        (x) => x.fromId !== parseInt(usrId, 10) && x.readStatus !== true
      );
      if (hasUnread) {
        updateMessageRead({ id: message.id, userId: usrId });
      }
    }
  }, [appMsgListData, message?.id, usrId, updateMessageRead]);

  // Update component user status in Redux/db once message read status is successfully patched
  const handleUpdateComponent = useCallback((compItems) => {
    if (!message || !componentUserStatus) return;
    const comp = componentUserStatus.filter((x) => x.compId === 9);
    let updCompItems = "";
    if (comp.length > 0) {
      updCompItems = comp[0].compItems;
    }
    const compObj = {
      compName: "Messages",
      performerId: currentUser?.id,
      compItems: compItems,
      ciid: message.ciid,
      wiid: message.wiid,
      iiid: message.iiid,
      compId: 9,
    };
    if (compItems !== "" && compItems !== updCompItems) {
      updateComponentsUserStatus(compObj);
    }
  }, [componentUserStatus, currentUser?.id, message, updateComponentsUserStatus]);

  useEffect(() => {
    if (isReadUpdateSuccess && messageList.length > 0) {
      const msgItems = messageList.map((x) => x.id).join(",");
      if (msgItems !== "") {
        handleUpdateComponent(msgItems);
        resetReadUpdate();
        if (handleSendMessage) handleSendMessage();
      }
    }
  }, [isReadUpdateSuccess, messageList, handleUpdateComponent, handleSendMessage, resetReadUpdate]);

  // Handle message post submission success (upload attachments and clear fields)
  useEffect(() => {
    if (addedNewMessageStatus) {
      if (message?.id > 0) {
        const currentContent = content;
        const currentDocuments = documents;
        const uploadUrls =
          addedNewMessageStatus?.sasUrls ||
          addedNewMessageStatus?.uploadSasUrls ||
          [];

        if (uploadUrls.length > 0) {
          currentDocuments.forEach((file, key) => {
            if (uploadUrls[key]?.uploadUrl) {
              uploadFileToBlob(file.file, uploadUrls[key].uploadUrl, () => { });
            }
          });
        }

        if (handleSupportMessage)
          handleSupportMessage(currentContent, addedNewMessageStatus);

        setDocuments([]);
        setContent("");
        setEditorResetKey((key) => key + 1);
        setBtnSendProcess(false);
        if (fileInputRef.current) fileInputRef.current.value = "";
        setAttachmentShowHide(false);
        resetAddAppMessage();
      }
    }
  }, [addedNewMessageStatus, message?.id, content, documents, handleSupportMessage, resetAddAppMessage]);

  const handleChange = useCallback((newContent) => {
    setContent(newContent);
  }, []);

  const onFileChange = useCallback((event) => {
    const incomingDocuments = Array.from(event.target.files || []).map((file) => ({
      name: file.name,
      type: file.type,
      size: file.size,
      file: file,
    }));

    if (incomingDocuments.length === 0) return;
    setDocuments((prevDocuments) => [...prevDocuments, ...incomingDocuments]);
    event.target.value = "";
  }, []);

  const handleClick = useCallback((event) => {
    console.log(event);
  }, []);

  const onSubmit = useCallback(() => {
    if (btnSendProcess) return;

    if (!getPlainText(content) && documents.length === 0) {
      getAlert("", "Please write a message or attach a file before sending.", "warning");
      return;
    }

    setBtnSendProcess(true);
    const data = new FormData();
    data.append("message", content);
    data.append("performerId", usrId);
    data.append("communication", JSON.stringify(message));
    data.append("files", JSON.stringify(documents.map(x => ({ name: x.name, type: x.type, size: x.size }))));
    addAppMessage(data);
  }, [btnSendProcess, content, documents, usrId, message, addAppMessage]);

  const handleFileRemove = useCallback((item) => {
    setDocuments((prevDocuments) => prevDocuments.filter((doc) => doc !== item));
  }, []);

  const handleAttachmentShowHide = useCallback(() => {
    setAttachmentShowHide((prev) => !prev);
  }, []);

  return (
    <Modal
      show={msgShowHide}
      size="xl"
      centered
      onHide={() => handleMsgModalShowHide("")}
      dialogClassName="messaging-popup-modal-dialog"
      contentClassName="messaging-popup-modal-content"
    >
      <style>
        {`
          .messaging-popup-modal-dialog {
            max-width: ${MESSAGING_POPUP_STYLES.modalDialog.maxWidth};
          }
          .messaging-popup-modal-content {
            border-radius: ${MESSAGING_POPUP_STYLES.modalContent.borderRadius};
            overflow: ${MESSAGING_POPUP_STYLES.modalContent.overflow};
            border: ${MESSAGING_POPUP_STYLES.modalContent.border};
            box-shadow: ${MESSAGING_POPUP_STYLES.modalContent.boxShadow};
          }
          /* Custom scrollbar for history card */
          .history-scroll::-webkit-scrollbar {
            width: 6px;
          }
          .history-scroll::-webkit-scrollbar-track {
            background: #f1f5f9;
            border-radius: 10px;
          }
          .history-scroll::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 10px;
          }
          .history-scroll::-webkit-scrollbar-thumb:hover {
            background: #94a3b8;
            border-radius: 10px;
          }
          `}
      </style>

      <Modal.Header style={MESSAGING_POPUP_STYLES.modalHeader}>
        <div style={MESSAGING_POPUP_STYLES.headerContent}>
          <Modal.Title as="div" style={MESSAGING_POPUP_STYLES.titleWrap}>
            <div style={MESSAGING_POPUP_STYLES.headerIcon}>
              <i className="fa fa-comments" aria-hidden="true"></i>
            </div>
            <div>
              <div style={MESSAGING_POPUP_STYLES.title}>Conversation</div>
              <div style={MESSAGING_POPUP_STYLES.subtitle}>
                Review replies and send a secure message.
              </div>
            </div>
          </Modal.Title>
          <button
            type="button"
            style={MESSAGING_POPUP_STYLES.closeButton}
            onClick={() => handleMsgModalShowHide("")}
            aria-label="Close messages popup"
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </Modal.Header>

      <Modal.Body style={MESSAGING_POPUP_STYLES.modalBody}>
        <div className="history-scroll" style={MESSAGING_POPUP_STYLES.historyCard}>
          {messageList.length > 0 ? (
            messageList.map((item) => (
              <MessagingList
                key={item.id}
                message={item}
                handleClick={handleClick}
                profilePicData={profilePicData}
              ></MessagingList>
            ))
          ) : (
            <div style={MESSAGING_POPUP_STYLES.emptyHistory}>
              No conversation messages yet. Write a reply below to start the discussion.
            </div>
          )}
        </div>

        <div style={MESSAGING_POPUP_STYLES.editorCard}>
          <div style={MESSAGING_POPUP_STYLES.sectionTitle}>
            <i className="fa fa-pencil" aria-hidden="true"></i>
            Write a Reply
          </div>

          {documents.length > 0 && (
            <div style={MESSAGING_POPUP_STYLES.fileList}>
              {documents.map((file, index) => (
                <div key={`${file.name}-${index}`} style={MESSAGING_POPUP_STYLES.fileRow}>
                  <div style={MESSAGING_POPUP_STYLES.fileMeta}>
                    <div style={MESSAGING_POPUP_STYLES.fileName}>{file.name}</div>
                    <div style={MESSAGING_POPUP_STYLES.fileSubtext}>
                      {formatFileSize(file.size)}
                      {file.type ? ` | ${file.type}` : ""}
                    </div>
                  </div>
                  <button
                    type="button"
                    style={MESSAGING_POPUP_STYLES.removeButton}
                    onClick={() => handleFileRemove(file)}
                    aria-label={`Remove ${file.name}`}
                  >
                    <i className="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              ))}
            </div>
          )}

          <LexicalEditor
            key={editorResetKey}
            value={content}
            onChange={handleChange}
          />



          <input
            type="file"
            ref={fileInputRef}
            onChange={onFileChange}
            aria-label="Add message attachments"
            multiple
            style={{ display: "none" }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer style={MESSAGING_POPUP_STYLES.modalFooter}>
        <div style={MESSAGING_POPUP_STYLES.footerActions}>
          <button
            type="button"
            style={MESSAGING_POPUP_STYLES.closeAction}
            onClick={() => handleMsgModalShowHide("")}
          >
            <i className="fa fa-times" aria-hidden="true"></i>
            Close
          </button>
          <button
            type="button"
            style={MESSAGING_POPUP_STYLES.attachButton}
            onClick={() => fileInputRef.current?.click()}
            disabled={btnSendProcess}
          >
            <i className="fa fa-paperclip mr-2" aria-hidden="true"></i>
            Add Files
          </button>

          <button
            type="button"
            style={{
              ...MESSAGING_POPUP_STYLES.sendButton,
              ...(btnSendProcess ? MESSAGING_POPUP_STYLES.sendButtonDisabled : {}),
            }}
            onClick={onSubmit}
            disabled={btnSendProcess}
          >
            <i
              className={`fa ${btnSendProcess ? "fa-circle-o-notch fa-spin" : "fa-paper-plane-o"} mr-2`}
              aria-hidden="true"
            ></i>
            {btnSendProcess ? "Sending..." : "Send Reply"}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};


export default MessagingPopup;
